export default __webpack_public_path__ + "d0be6317b2f6f23109814a2f7ace2ee6.svg";